import { BrowserRouter as Router, } from 'react-router-dom';
import { Suspense } from 'react';
import { Toaster } from 'react-hot-toast';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import MainLayout from './layouts/MainLayout';
import AppRoutes from './routes/index';
import NotificationToast from './features/notifications/components/NotificationToast';
import LoadingSpinner from './shared/components/LoadingSpinner';
import OfflineBanner from './shared/components/OfflineBanner';
import SEO from './shared/components/SEO';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
});

function App() {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <Router>
          <LanguageProvider>
            <SEO />
            <AuthProvider>
              <MainLayout>
                <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><LoadingSpinner /></div>}>
                  <AppRoutes />
                </Suspense>
              </MainLayout>
              <NotificationToast />
              <OfflineBanner />
              <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
            </AuthProvider>
          </LanguageProvider>
        </Router>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
